import React from "react";
import { motion } from "framer-motion";
import aboutus from "../../assets/img/AboutUs/aboutus-2.jpg";
import aboutus1 from "../../assets/img/AboutUs/aboutus-3.jpg";
import aboutus2 from "../../assets/img/AboutUs/aboutus-4.jpg";
import aboutus3 from "../../assets/img/AboutUs/aboutus-5.jpg";
import { Helmet } from "react-helmet";

export default function AboutUs() {
  return (
    <>
      <Helmet>
        <title>About Us | Maids Service Pakistan</title>
        <meta
          name="description"
          content="Maids Service Pakistan offers trusted, affordable home cleaning solutions across Lahore, Karachi, Islamabad & all major cities. Book professional maids online 24/7."
        />
      </Helmet>

      <div className="about-section lightBg" id="about">
        <div className="container">
          <div className="row textCenter headerInfo section-heading">
            <div className="col-12">
              <h2 className="font40 extraBold textCenter">About Us</h2>
            </div>
          </div>

          <div className="row flexSpaceCenter">
            <div className="col-md-6 col-xs-12">
              <div className="about-content padBot">
                <h4 className="font15 semiBold">
                  Your Trusted Partner for Home Cleaning in Pakistan
                </h4>
                <h2 className="font30 extraBold">
                  Expert Maids Across Pakistan — Reliable & Affordable
                </h2>
                <p className="font20">
                  We provide expert maid services 24/7 across all major cities
                  in Pakistan. Whether you need daily, weekly, bi-weekly, or
                  monthly cleaning — we've got flexible plans tailored just for
                  you. Our professionally trained staff ensures spotless homes,
                  deep cleaning, and regular housekeeping with complete safety
                  and trust. Trusted by families, professionals, and businesses
                  from Karachi to Islamabad.
                </p>
                <ul className="font15">
                  <li>✔️ Available 24/7 across Pakistan – weekends & holidays included</li>
                  <li>✔️ One-time, weekly, bi-weekly, and monthly cleaning plans</li>
                  <li>✔️ Deep cleaning for kitchens, bathrooms, bedrooms & more</li>
                  <li>✔️ Fully trained, background-verified & locally trusted staff</li>
                  <li>✔️ Easy online booking & instant support in Urdu & English</li>
                </ul>
                <br />
                <a className="btnPrimary" href="#contact">
                  Request a Maid Now
                </a>
              </div>
            </div>

            <div className="col-md-6 col-xs-12">
              <div className="about-image textCenter">
                <motion.div
                  initial={{ opacity: 0, x: 100 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ duration: 0.8 }}
                >
                  <img
                    src={aboutus}
                    loading="lazy"
                    alt="Professional maid cleaning service in Pakistan"
                    className="radius8 about-img"
                  />
                </motion.div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="darkBgAbout feature-section">
        <div className="container">
          <motion.div
            initial={{ opacity: 0, x: 100 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
          >
            <div className="row textCenter">
              <div className="col-md-4 col-sm-12 feature-column">
                <div className="feature-box whiteBg radius8 shadow">
                  <img
                    src={aboutus3}
                    alt="Complete home cleaning service"
                    className="feature-icon"
                  />
                  <h3 className="font20 semiBold">Complete Home Cleaning</h3>
                  <p className="font12">
                    Thorough cleaning of every room, kitchen, and bathrooms. We
                    cover Lahore, Karachi, Islamabad & more.
                  </p>
                </div>
              </div>

              <div className="col-md-4 col-sm-12 feature-column">
                <div className="feature-box whiteBg radius8 shadow">
                  <img
                    src={aboutus2}
                    alt="Flexible maid service plans"
                    className="feature-icon"
                  />
                  <h3 className="font20 semiBold">Flexible Plans & Scheduling</h3>
                  <p className="font12">
                    Choose daily, weekly, bi-weekly, or monthly visits. Reschedule
                    easily via WhatsApp or our portal.
                  </p>
                </div>
              </div>

              <div className="col-md-4 col-sm-12 feature-column">
                <div className="feature-box whiteBg radius8 shadow">
                  <img src={aboutus1} alt="24/7 customer support Pakistan" className="feature-icon" />
                  <h3 className="font20 semiBold">24/7 Local Support</h3>
                  <p className="font12">
                    Our Pakistan-based support team is always ready to assist you
                    in Urdu and English.
                  </p>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>

      {/* Updated Styles – New Color Scheme (Trust Blue) */}
      <style>{`
        .lightBg {
          background: #f9f9f9;
          padding: 60px 0;
        }

        .feature-column {
          padding: 10px;
        }

        .about-section {
          margin-top: 5%;
        }

        /* Responsive heading fix */
        @media (max-width: 860px) {
          .headerInfo {
            text-align: center !important;
            justify-content: center;
          }
        }

        .padBot {
          padding-bottom: 5px;
        }

        /* NEW PRIMARY COLOR: Trust Blue */
        .darkBgAbout {
          background: #2c7da0;
          padding: 60px 0;
        }

        .textCenter {
          text-align: center;
        }

        .radius8 {
          border-radius: 8px;
        }

        .shadow {
          box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
        }

        .btnPrimary {
          background: #2c7da0;
          color: white;
          padding: 10px 25px;
          text-decoration: none;
          border-radius: 6px;
          font-weight: 600;
          transition: 0.3s ease;
          display: inline-block;
        }

        .btnPrimary:hover {
          background: #1f5068;
        }

        .about-img {
          width: 100%;
          max-height: 400px;
          object-fit: cover;
        }

        .feature-icon {
          width: 100%;
          max-height: 200px;
          object-fit: cover;
          border-radius: 10px;
          margin-bottom: 15px;
        }

        .feature-box {
          padding: 30px;
          text-align: center;
          height: 100%;
        }

        .feature-col {
          margin-bottom: 30px;
        }

        .font12 {
          font-size: 12px;
        }

        .font15 {
          font-size: 15px;
        }

        .font20 {
          font-size: 20px;
        }

        .font40 {
          font-size: 40px;
        }

        .semiBold {
          font-weight: 600;
        }

        .extraBold {
          font-weight: 800;
        }

        @media (max-width: 768px) {
          .font40 {
            font-size: 28px;
          }

          .feature-box {
            padding: 20px;
          }
        }
      `}</style>
    </>
  );
}